module.exports = __webpack_public_path__ + "5292e25c0a239bdee7e8302b6837449d.png";